export const PRODUCT_FRUITS_KEYS = {
  BUSINESS_TYPE: 'user_business_type',
  PRIORITY_PACING: 'user_priority_budget_pacing_reporting',
  PRIORITY_AUTOMATION: 'user_priority_budget_automation',
  PRIORITY_OVERSPEND: 'user_priority_stop_overspends',
  PRIORITY_PERFORMANCE: 'user_priority_track_performance',
}